import styled from 'styled-components';
const HeaderNavigationStyle = styled.nav `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
`;
export default HeaderNavigationStyle;
//# sourceMappingURL=HeaderNavigationStyle.js.map